module.exports = __webpack_public_path__ + "static/media/horse.139af067.gif";